<template>
  <div class="tabs-wrapper">
    <ul class="tabs-header">
      <li
        v-for="(tab, index) in tabs"
        class="tabs-header-item"
        :key="tab.title"
        :class="{ 'active text-purple-gradient': tab.isActive }"
        @click="selectTab(index)"
      >
        {{ tab.title }}
      </li>
    </ul>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    value: Number,
  },
  created() {
    this.tabs = this.$children;
  },
  mounted() {
    this.selectTab(0);
  },
  data: () => ({
    tabs: [],
  }),
  methods: {
    selectTab(i) {
      this.$emit('input', i);
      this.tabs.forEach((tab, index) => {
        this.$set(tab, 'isActive', index === i);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.tabs-header {
  @apply flex justify-around;
  min-height: 40px;
}
.tabs-header-item {
  @apply inline-block;
  color: rgba(38, 38, 38, 0.3);

  &.active {
    @apply relative;
    &:after {
      @apply absolute inline-block left-0 right-0 bottom-0 mx-auto;
      content: '';
      width: 8px;
      height: 8px;
      border-radius: 8px;
      background: linear-gradient(to right, #2245ff, #540deb);
    }
  }
}
</style>
